import { render, staticRenderFns } from "./ShippingUnitsGridDGsModal.vue?vue&type=template&id=f54642b0&scoped=true"
import script from "./ShippingUnitsGridDGsModal.vue?vue&type=script&lang=js"
export * from "./ShippingUnitsGridDGsModal.vue?vue&type=script&lang=js"
import style0 from "./ShippingUnitsGridDGsModal.vue?vue&type=style&index=0&id=f54642b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54642b0",
  null
  
)

export default component.exports